export const PUBLIC_IMAGE_URL = 'files/download/public?f=';
export const GANTT_EXPORT_SERVICE_URL = 'https://gantt-export.getpacer.com/gantt';

export const SUBSCRIPTION_HEADER_NAME = 'Eh-Sub';

export const MAX_SUPPORT_TICKET_CHAR_LENGTH = 1000;
export const MAX_LOCATION_COMMENTS_CHAR_LENGTH = 1000;
export const MAX_PHASE_DESCRIPTION_CHAR_LENGTH = 200;

export const DEFAULT_PAGE_SIZE = 100;

export const EVENT_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT = 'D MMM YYYY';
export const DATETIME_FORMAT = 'D MMM YYYY h:mm:ss a';
export const MIN_DATE_FORMATTED = '1 Jan 0001';

export const MOBILE_WINDOW_BREAKPOINT = 500;

export const HEADER_MOBILE_BREAKPOINT = 1000;

export const MAX_TASK_STEP_COUNT = 20;

export const MAX_LOCATIONS_SELECTED = 75;

export const MAX_NUM_FAQS = 6;
export const MAX_NUM_GOALGROUPS = 6;
export const MAX_NUM_TASK_LINKS = 4;

export const MAX_NUM_CONFETTI = 2;

export const ENVIRONMENTS = {
	DEV: 'DEV',
	TEST: 'TEST',
	PROD: 'PROD',
};

export const USER_LOCATION_ACCESS_OPTIONS = {
	NO: {
		value: 'no',
		label: 'No',
	},
	YES: {
		value: 'yes',
		label: 'Yes',
	},
	RULES: {
		value: 'rules',
		label: 'Yes, based on rule',
	},
};

export const WorkflowStepNames = {
	PasswordExpired: 'PASSWORD_EXPIRED',
	IsEHAdmin: 'IS_EH_ADMIN',
	ChooseSubscription: 'CHOOSE_SUBSCRIPTION',
	SubscriptionDisclaimer: 'SUBSCRIPTION_DISCLAIMER',
	InvalidDefaultLocation: 'INVALID_DEFAULT_LOCATION',
	SendToDestinationPage: 'SEND_TO_DESTINATION_PAGE',
	RequireMissingProfileInput: 'REQUIRE_MISSING_PROFILE_INPUT',
	ConfigureTfa: 'CONFIGURE_TFA',
};

export const defaultLogoColors = {
	logoColor: '#0608B5',
	highlightColor: '#727383',
};
export const DEFAULT_ACCENT_COLOR = '#03a9f4';

export const SUPPORT_TICKET_ID_URL_PARAM = {
	RequestorLink: 'tid',
	AgentLink: 'taid',
};
export const supportTicketStatuses = {
	Open: 1,
	Pending: 2,
	Solved: 3,
};

export const DailyDigestPopover = {
	Title: 'Daily Digest',
	Body: "Emails you about tasks that have recently changed. For example, if a task has become past due, if a task has been assigned to your name, and/or if a task's instructions have changed.",
};

export const WeeklyDigestPopover = {
	Title: 'Weekly Digest',
	Body: 'Sends an email that includes a list of upcoming and past due milestones and tasks.',
};

export const TASK_LIST_VIEWS = {
	List: {
		id: 0,
		value: 'list',
		label: 'Table',
		icon: 'fa-table',
	},
	Calendar: {
		id: 1,
		value: 'calendar',
		label: 'Calendar',
		icon: 'fa-calendar',
	},
	Gantt: {
		id: 2,
		value: 'gantt',
		label: 'Gantt',
		icon: 'fa-chart-gantt',
	},
	ResourceAllocation: {
		id: 3,
		value: 'resourceAllocation',
		label: 'Workload',
		icon: 'fa-diagram-cells',
	},
	Kanban: {
		id: 4,
		value: 'kanban',
		label: 'Kanban',
		icon: 'fa-square-kanban',
	},
};

export const HEATMAP_VIEWS = {
	Month: {
		value: 'month',
		label: 'Month',
	},
	Week: {
		value: 'week',
		label: 'Week',
	},
	Day: {
		value: 'day',
		label: 'Day',
	},
};

export const GANTT_ZOOM_LEVELS = {
	Month: {
		value: 0,
		name: 'month',
	},
	Week: {
		value: 1,
		name: 'week',
	},
	Day: {
		value: 2,
		name: 'day',
	},
};

export const GANTT_LINK_TYPES = {
	FinishToStart: '0',
	StartToStart: '1',
	FinishToFinish: '2',
	StartToFinish: '3',
};

export const TASK_LIST_URL_PARAMS = {
	LocationKeys: 'l',
	Name: 'n',
	TaskId: 't',
	ProjectId: 'p',
	ProjectIds: 'p',
	IsMilestone: 'm',
	TargetDateStart: 'tds',
	TargetDateEnd: 'tde',
	StartDateStart: 'sds',
	StartDateEnd: 'sde',
	ResponsibleUserName: 'r',
	StatusId: 's',
	StatusIds: 's',
	DepartmentId: 'd',
	DepartmentIds: 'd',
	DisciplineId: 'disc',
	PhaseId: 'ph',
	PhaseIds: 'ph',
	CommunityId: 'c',
	CommunityIds: 'c',
	TagId: 'tags',
	RecentlyUpdated: 'u',
	AllTasks: 'all',
	AllLocations: 'la',
	AdditionalInfo: 'ai',
	BaselineName: 'bn',
	DropDownOption: 'ddo',
};

export const BASELINE_TASK_LIST_URL_PARAMS = {
	BaselineId: 'bid',
	BaselineTaskId: 'btid',
};

export const EXTERNAL_TASK_COMPLETION_PARAMS = {
	LocationKey: 'l',
	UserKey: 'u',
	SliceName: 's',
};

export const LOCATION_DASHBOARD_URL_PARAMS = {
	locationKey: 'l',
};

export const CROSS_BASELINE_SEARCH_URL_PARAMS = {
	name: 'n',
};

export const FREE_TRIAL_URL_PARAMS_FROM_MARKETING_SITE = {
	firstName: 'firstName',
	lastName: 'lastName',
	email: 'email',
	company: 'company',
	template: 'template',
};

export const TASK_COMPLETION_SLICES = {
	Community: 'Community',
	Department: 'Department',
	Discipline: 'Discipline',
	Phase: 'Phase',
	Responsible: 'Responsible',
	Project: 'Project',
	Brand: 'Brand',
	Continent: 'Continent',
	ResponsibleUser: 'Responsible User',
	Location: 'Location',
	Tag: 'Tag',
};

export const GRAPH_STATUSES = {
	NotApplicable: {
		id: 'NotApplicable',
		label: 'Not Applicable',
		color: '#ACE874',
	},
	Complete: {
		id: 'Complete',
		label: 'Complete',
		color: '#40AF32',
	},
	PastDue: {
		id: 'PastDue',

		label: 'Past Due',
		color: '#D20005',
	},
	InProgress: {
		id: 'InProgress',
		label: 'In Progress',
		color: '#EEBB08',
	},
	NotDue: {
		id: 'NotDue',
		label: 'Not Due',
		color: '#CDCCCC',
	},
};

export const GOAL_STATUSES = {
	DarkGreen: {
		color: '#40AF32',
	},
	MediumGreen: {
		color: '#8cd14d',
	},
	LightGreen: {
		color: '#ACE874',
	},
	Remaining: {
		color: '#CDCCCC',
		title: 'Remaining to Goal',
	},
	Exceeding: {
		color: '#EEBB08',
		title: 'Exceeding Goal',
	},
};

export const QUICK_LINK_TYPES = {
	Total: {
		title: 'Total',
		color: '#565656',
	},
	StartingSoon: {
		title: 'Starting Soon',
		color: '#CDCCCC',
	},
	DueSoon: {
		title: 'Due Soon',
		color: '#CDCCCC',
	},
	PastDue: {
		title: 'Past Due',
		color: '#D20005',
	},
	PastDueInProgress: {
		title: 'Past In Progress',
		color: '#EEBB08',
	},
};

export const CROSS_BASELINE_SEARCH_ATTRIBUTES = {
	TaskName: 'Task Name',
	Department: 'Department',
	Phase: 'Phase',
	Discipline: 'Discipline',
	AdditionalInfo: 'Additional Info',
	ContactInfo: 'Contact Info',
	LinkName: 'Link Name',
	LinkUrl: 'Link URL',
};

export const CROSS_BASELINE_TASK_LINK_SEARCH_ATTRIBUTES = {
	LinkURL: 'Link URL',
	LinkName: 'Link Name',
};

export const CORE_STATUSES = {
	NotStarted: 1,
	NotApplicable: 2,
	InProgress: 3,
	Complete: 4,
};

// Colors pulled from v4 Task List
export const TASK_LIST_COLORS_CODES = {
	PastDue: 'past-due',
	Complete: 'complete',
	InProgress: 'in-progress',
	DueThisWeek: 'due-this-week',
};

export const MAX_FILE_SIZE = 104857600;

export const FILE_STATUSES = {
	Pending: 1,
	Approved: 2,
	Denied: 3,
};

export const REPORT_IDS = {
	TaskList: 1,
	PastDueTaskList: 2,
	CoachSummary: 3,
	MilestonesCrosstab: 4,
	ProjectCrosstab: 5,
	LocationSummaryPerProject: 6,
	BaselineTaskList: 7,
	BaselineImportToolDropdownValues: 8,
	ProjectLocationsList: 9,
	ProjectTasksList: 10,
	ProjectList: 11,
	ProjectDeployment: 12,
	ProjectsPerLocation: 13,
	UserList: 14,
	LocationsList: 15,
	LocationTaskSummary: 16,
	SupportTickets: 17,
	GMSummary: 18,
	PastDuePreRequisiteTask: 19,
};

export const REPORT_URL_PARAMS = {
	DepartmentId: 'd',
	LocationKeys: 'l',
	StatusId: 's',
	IsMilestone: 'm',
	ProjectId: 'p',
	BaselineId: 'b',
	TargetDateStart: 'tds',
	TargetDateEnd: 'tde',
	ResponsibleUserName: 'r',
	DisciplineId: 'disc',
	PhaseId: 'ph',
	CommunityId: 'c',
	TagId: 'tags',
};

export const REPORT_EXPORT_FILE_TYPES = {
	Excel: 'EXCEL',
	Pdf: 'PDF',
};

export const CUSTOM_LOGIN_SUBSCRIPTIONS = {
	TheDrew: {
		name: 'thedrew',
		id: 43,
	},
};

export const GOODBYE_MESSAGES = ['Goodbye for now', 'We miss you already', 'Have a super fantastic day', 'ciao | до свидания | adios'];

export const FONT_FAMILY = 'Greycliff, sans-serif';

export const FEEDBACK_OPTIONS = [
	{
		id: '1',
		label: 'This is helpful',
	},
	{
		id: '2',
		label: 'This task is no longer relevant',
	},
	{
		id: '3',
		label: 'The task needs more information/explanation',
	},
	{
		id: '4',
		label: 'Please add a link (please enter link below)',
	},
	{
		id: '5',
		label: 'The link is not correct',
	},
];

export const FINANCIALS_STATUSES = {
	Actual: {
		color: '#CDCCCC',
		title: 'Actual',
	},
	RemainingBudget: {
		color: '#40AF32',
		title: 'Remaining Budget',
	},
};

export const CONFETTI_ANIMATION_TYPE = {
	Realistic: 'realistic',
	Cannon: 'cannon',
};

export const CONFETTI_CONFIG = {
	position: 'fixed',
	pointerEvents: 'none',
	width: '100%',
	height: '100%',
	top: 0,
	left: 0,
	zIndex: 50000,
};

export const EVENT_TYPE = {
	ConfettiCannon: 'confetti:cannon',
};

export const PROJECT_LOCATION_BULK_UPDATE_OPTIONS = {
	BulkUpdate: {
		value: 'bulkUpdate',
		label: 'Bulk Update',
		icon: 'share-alt',
	},
	AddBaseline: {
		value: 'addBaseline',
		label: 'Add Baseline',
		icon: 'share-alt',
	},
	Publish: {
		value: 'publish',
		label: 'Publish',
		icon: 'share-alt',
	},
	RemoveScope: {
		value: 'removeScope',
		label: 'Remove Scope',
		icon: 'trash-alt',
	},
	ChangeManager: {
		value: 'changeManager',
		label: 'Change Manager',
		icon: 'users',
	},
	ChangeZeroDate: {
		value: 'changeZeroDate',
		label: 'Change Dates',
		icon: 'calendar-alt',
	},
	Unpublish: {
		value: 'unpublish',
		label: 'Unpublish',
		icon: 'undo',
	},
	OnHold: {
		value: 'onHold',
		label: 'On Hold',
		icon: 'pause',
	},
	OffHold: {
		value: 'offHold',
		label: 'Off Hold',
		icon: 'play',
	},
};

export const PROJECT_TASKS_LIST_UPDATE_OPTIONS = {
	BulkUpdate: {
		value: 'bulkUpdate',
		label: 'Bulk Update',
		icon: 'share-alt',
	},
	UpdateAttributes: {
		value: 'updateAttributes',
		label: 'Update Attributes',
		icon: 'share-alt',
	},
	BulkPushdown: {
		value: 'bulkPushdown',
		label: 'Bulk Pushdown',
		icon: 'share-alt',
	},
	PreviewPushdown: {
		value: 'previewPushdown',
		label: 'Preview Pushdown',
		icon: 'share-alt',
	},
	OrderTasks: {
		value: 'orderTasks',
		label: 'Order Tasks',
		icon: 'trash-alt',
	},
};

export const PROJECT_LOCATION_WAIVER_STATUSES = {
	Pending: 1,
	Approved: 2,
	Denied: 3,
};

export const TASK_LIST_MENU_ITEMS = {
	Tasks: {
		value: 'tasks',
		displayName: 'Tasks',
		urlParams: null,
		ordinal: 0,
	},
	AllTasks: {
		value: 'allTasks',
		displayName: 'All Tasks',
		urlParams: {
			allTasks: [1], // Send the all tasks param with a value of one to indicate filters should be cleared
		},
		ordinal: 1,
	},
	MyTasks: {
		value: 'myTasks',
		displayName: 'My Tasks',
		urlParams: {
			responsibleUserName: null, // FirstName LastName
		},
		ordinal: 2,
	},
	MyTasksAllLocations: {
		value: 'myTasksAllLocations',
		displayName: 'My Tasks at All Locations',
		urlParams: {
			responsibleUserName: null, // FirstName LastName
		},
		ordinal: 3,
	},
	MyFollowingTasks: {
		value: 'myFollowingTasks',
		displayName: 'My Department Tasks',
		urlParams: null,
		ordinal: 4,
	},
	PastDueTasks: {
		value: 'pastDueTasks',
		displayName: 'Past Due Tasks',
		urlParams: null,
		ordinal: 5,
	},
	DueSoonTasks: {
		value: 'dueSoonTasks',
		displayName: 'Upcoming Tasks Due',
		urlParams: null,
		ordinal: 6,
	},
	StartingSoonTasks: {
		value: 'startingSoonTasks',
		displayName: 'Upcoming Tasks Starting',
		urlParams: null,
		ordinal: 7,
	},
};

export const CORPORATE_DASHBOARD_DEFAULT = {
	CORPORATE_DASHBOARD_VIEW_DEFAULT_ID: 'defaultId',
	SAVE_CURRENT_VIEW_TEXT: 'Save Current View',
	SAVE_CURRENT_VIEW_ID: '-92',
};

export const CORPORATE_DASHBOARD_DEFAULT_MANAGE = {
	SAVE_CURRENT_VIEW_MANAGE_TEXT: 'Manage Custom Views',
	SAVE_CURRENT_VIEW_MANAGE_ID: '-91',
};

export const SortColumnsType = {
	PmDashboardPageLocations: 0,
	PmDashboardPageTasks: 1,
	AdminPageSubscriptionUsers: 2,
	AdminPageBaselineTasks: 3,
	AdminPageProjects: 4,
	AdminPageLocations: 5,
};
